import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={styles["community-log-icon"] || "community-log-icon"} viewBox="0 0 52 49" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><path fill="#000" fillRule="nonzero" d="M3.847 6.238H26.29v-3H.847v45.38H48.29v-23.38h-3v20.38H3.847z" /><path d="M17.443 27.665l.018 6.15 6.06-.056 25.48-25.48-6.086-6.086-25.472 25.472z" stroke="#000" strokeWidth="3" /></g></svg>;